import { CartProvider } from "react-use-cart";
import "./App.css";
import AppRoutes from "./Routes";
import { AuthProvider } from "./AuthContext";
import { BrowserRouter, useLocation } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";

function AppWrapper() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]); // ✅ only fires when path actually changes

  return <AppRoutes />;
}

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.body.dir = i18n.language === "ar" || i18n.language === "ur" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <AppWrapper /> {/* ✅ was <AppRoutes /> — AppWrapper must be inside BrowserRouter to use useLocation */}
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;